import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { hide } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = ['bookmark'];
  static values = {
    articleId: Number,
  };

  connect() {
    if (CurrentUser.isGuest()) {
      hide(this.bookmarkTarget);
    } else {
      this.updateBookmarkDisplay();
    }
  }

  updateBookmarkDisplay() {
    const isActive = CurrentUser.bookmarks().includes(this.articleIdValue);

    this.bookmarkTarget.classList.toggle('is-active', isActive);
    this.bookmarkTarget.classList.toggle('is-inactive', !isActive);
  }
}
